import { ContainerModule } from '@evertel/di'
import {
    MessageReadsController, MessageWallController, MessageController,
    MessageReactionsController, MessageReactedByController,
    CreateMessageController, MessageForwardController, MessageSearchController, DrawerController,
    RepliesViewController
} from './controller'


const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(MessageReadsController).toSelf()
        m.bind(MessageWallController).toSelf()
        m.bind(MessageController).toSelf()
        m.bind(MessageReactionsController).toSelf()
        m.bind(MessageReactedByController).toSelf()
        m.bind(CreateMessageController).toSelf()
        m.bind(MessageForwardController).toSelf()
        m.bind(MessageSearchController).toSelf()
        m.bind(DrawerController).toSelf()
        m.bind(RepliesViewController).toSelf()
    })
]

export { DI_MODULES }
